import React from 'react';

function TrendComponent() {
    return <div>TrendComponent</div>;
}

export default TrendComponent;
